'use client';

import { cn } from '@/lib/utils';
import type { ReactElement } from 'react';
import { useHealth } from '@/lib/services/health/health.service';

export default function Status(): ReactElement {
  const { health } = useHealth();

  return (
    <div className="absolute flex items-center justify-center gap-1 bottom-0 right-0 opacity-80">
      <div
        className={cn(
          'w-2.5 h-2.5 rounded-full',
          health.isPending ? 'bg-yellow-500' : health.isSuccess ? 'bg-green-500' : 'bg-red-500',
        )}
      />
      {health.data?.ping && <p className="text-xxs opacity-80">{health.data.ping}</p>}
    </div>
  );
}
